<div class="social-intake-container">
  <ng-switch [ngSwitch]="currentFormState">
    <ng-container *ngSwitchCase="socialIntakeFormState.FORM" [ngTemplateOutlet]="form"></ng-container>
    <ng-container *ngSwitchCase="socialIntakeFormState.PROCESSING" [ngTemplateOutlet]="processing"></ng-container>
    <ng-container *ngSwitchCase="socialIntakeFormState.ERROR" [ngTemplateOutlet]="error"></ng-container>
  </ng-switch>
</div>

<ng-template #form>
  <form
    class="social-intake-form"
    [formGroup]="socialIntakeForm"
    *ngIf="socialIntakeForm"
  >
    <section class="header-section">
      <h1>Let’s get you into care</h1>
      <p>Fill in the info below and we’ll get you connected with available providers that match your needs</p>
    </section>
  
    <!-- Preferences Section -->
    <section class="question-section preferences">
      <div class="section-header">
        <h2 class="iris-mb-02">Why are you interested in therapy or psychiatry?</h2>
        <p>Share what type of support you need, any provider preferences, or issues you would like to address.</p>
      </div>

      <iris-form-field class="preferences-field">
        <iris-text-area
          formControlName="openPreferences"
          [autoResizeEnabled]="true"
        >
        </iris-text-area>
      </iris-form-field>

      <iris-checkbox
        class="medication-management-checkbox"
        formControlName="medicationManagement"
      >
        I need help managing my medication
      </iris-checkbox>
    </section>

    <!-- Personal Information Section -->
    <section class="question-section personal-info">
      <h2>Tell us a little more about you:</h2>
      
      <div class="form-body">
        <iris-form-field class="grid-col-6" label="First name">
          <iris-text-input formControlName="firstName"> </iris-text-input>
        </iris-form-field>
  
        <iris-form-field class="grid-col-6" label="Last name">
          <iris-text-input formControlName="lastName"></iris-text-input>
        </iris-form-field>

        <div class="grid-col-12" formGroupName="location">
          <iris-form-field
            data-test="quick-intake-form-location-label-text"
            label="Location"
            [customErrorMessages]="{
              invalidLocation: 'Please select a valid location'
            }"
          >
            <iris-text-input
              formControlName="address"
              googleMapsAutoComplete
              placeholder="City or ZIP Code"
              (onAutoCompleteSelected)="locationSelected($any($event))"
              data-test="quick-intake-form-location-input"
            >
            </iris-text-input>
          </iris-form-field>
        </div>

        <not-in-your-state
          *ngIf="!availableInYourState"
          class="grid-col-12"
        ></not-in-your-state>

        <iris-form-field
          class="grid-col-12"
          data-test="quick-intake-form-payment-type-label-text"
          label="How will you by paying for care" 
        >
          <iris-dropdown
            formControlName="paymentType"
            [options]="paymentTypesInState$ | async"
            placeholder="Select a payment method"
            data-test="quick-intake-form-payment-type-dropdown"
          ></iris-dropdown>
          <iris-hint
            *ngIf="socialIntakeForm.controls.paymentType.disabled"
            data-test="quick-intake-form-payment-type-hint"
          >
            Select a location to unlock payment options
          </iris-hint>
        </iris-form-field>
      
        <iris-form-field 
          *ngIf="showInsurancePlans$ | async"
          class="grid-col-12"
          [label]="socialIntakeForm.controls.paymentType.value | insurancePlanLabel" 
          [customErrorMessages]="{
            hasUnsupportedPsychInsurance: 'Your previously selected plan does not cover Medication Management. Please select another plan'
          }"
        >
          <iris-dropdown
            formControlName="insurance"
            [options]="acceptedInsurances$ | async"
            placeholder="Select a plan"
          ></iris-dropdown>
        </iris-form-field>
      </div>
    </section>

    <footer class="form-footer">
      <iris-button
        class="continue-button"
        [disabled]="!socialIntakeForm.valid || !availableInYourState"
        (click)="continue()"
      >
        Continue
      </iris-button>

      <a
        class="provider-directory-link iris-link-quiet-responsive"
        [href]="providerDirectoryUrl"
        target="_blank"
      >Want to browse providers yourself? Explore our provider directory</a>
    </footer>
  </form>
</ng-template>

<ng-template #processing>
  <matching-progress></matching-progress>
</ng-template>

<ng-template #error>
  <div class="error-container">
    <h3>There was an error when submitting your request</h3>
    <p class="iris-mb-04">Please try again.</p>
    <iris-button (click)="backToForm()">Back to form</iris-button>
  </div>
</ng-template>
